<template>
  <div>
    <v-row>
      <v-col class="ml-3" cols="5">
        <v-row>
          <v-select
            background-color="#EDF2F7"
            filled
            item-text="name"
            v-model="select_type"
            :items="modlues"
            item-value="id"
            label="Module"
          ></v-select>
        </v-row>
      </v-col>
      <v-col class="ml-5" cols="5">
        <v-row>
          <v-autocomplete
            background-color="#EDF2F7"
            filled
            v-model="idSelect"
            item-text="name"
            item-value="id"
            :items="categories"
            label="Module"
          ></v-autocomplete>
        </v-row>
      </v-col>
      <v-col class="text-center ml-5" cols="1">
        <v-row>
          <v-btn color="primary" width="100" @click="sendMessage"> Thêm</v-btn>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { GET_LIST_CATEGORY } from "@/store/modules/category";
import { mapGetters } from "vuex";
import { GET_LIST_BRAND } from "@/store/modules/brand";
// import { GET_DETAIL_TAG } from "@/store/modules/tag";
export default {
  props: {},
  data() {
    return {
      idSelect: null,
      list_ids: null,
      select_type: "category",
      modlues: [
        {
          id: "category",
          name: "category",
        },
        // {
        //   id: "brand",
        //   name: "brand",
        // },
        // {
        //   id: "tag",
        //   name: "tag",
        // },
      ],
      //   dataModule: {
      //     type: this.select_type,
      //     id: this.idSelect,
      //   },
    };
  },
  methods: {
    sendMessage() {
      let dataModule = {
        type: this.select_type,
        id: this.idSelect,
      };
      if(!this.idSelect){
        alert("Vui lòng chọn danh mục");
      }else{
        this.$emit("inputData", dataModule);
      }
    },
  },
  watch: {
    select_type(val) {
      const _this = this;
      if (val == "category") {
        // this.config_blanco.banner.link.type = "category";
        this.$store.dispatch(`${GET_LIST_CATEGORY}`).then((data) => {
          if (data && data.data && data.data.length > 0) {
            _this.list_ids = data.data;
          } else {
            _this.list_ids = [];
          }
        });
      }
      if (val == "brand") {
        this.$store.dispatch(`${GET_LIST_BRAND}`).then((data) => {
          if (data && data.data && data.data.length > 0) {
            _this.list_ids = data.data;
          } else {
            _this.list_ids = [];
          }
        });
      }
      if (val == "tag") {
        // this.config_blanco.banner.link.type = "tag";
        this.list_ids = this.tags
        // this.$store.dispatch(`${GET_DETAIL_TAG}`).then((data) => {
        //   if (data && data.data && data.data.length > 0) {
        //     _this.list_ids = data.data;
        //   } else {
        //     _this.list_ids = [];
        //   }
        // });
      }
    },
  },
  computed: {
    ...mapGetters({
      categories: "categories",
      tags: "tags"
    }),
  },
  async created() {
    await this.$store.dispatch(`${GET_LIST_CATEGORY}`);
  },
};
</script>